module.exports = __webpack_public_path__ + "static/media/icon-projects.1910b2dc.svg";